import { Button } from "components/DesignSystem/Button/Button";
import Input from "components/DesignSystem/Input/Input";
import Modal from "components/DesignSystem/Modal/Modal";
import { FormikForm } from "components/FormikForm/FormikForm";
import { PriceInput } from "components/PriceInput/PriceInput";
import { adminCreditsSchema } from "formValidations/adminCreditsSchema";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { useToast } from "hooks/useToast";
import { useAddAdminCreditsMutation } from "store/apis/refrral";
import { BackendError } from "types/utils/error";
import { ModalProps } from "types/utils/modal";

export const AdminAddCreditsModal = ({ isOpen, close }: ModalProps) => {
  const { successToast, alertToast } = useToast();
  const { uuid: groupId } = useCurrentGroupContext();

  const [addAdminCredits, { isLoading }] = useAddAdminCreditsMutation();

  const onSubmit = async (values: { credits: string; description: string }) => {
    try {
      await addAdminCredits({
        groupId,
        credits: Number(values.credits),
        description: values.description,
      }).unwrap();
      close();
      successToast({ message: "Credits added successfully" });
    } catch (error) {
      alertToast({
        message: (error as BackendError)?.data?.error?.message,
      });
    }
  };

  return (
    <Modal.Root open={isOpen} onOpenChange={close}>
      <Modal.Content asChild>
        <FormikForm
          validationSchema={adminCreditsSchema}
          initialValues={{ credits: "", description: "" }}
          onSubmit={onSubmit}
        >
          {({ submitForm }) => (
            <>
              <Modal.Header>
                <Modal.Title>Add Promotion Credits</Modal.Title>
                <Modal.Close />
              </Modal.Header>
              <Modal.Body className="t-flex t-flex-col t-gap-4">
                <PriceInput
                  name="credits"
                  label="Credits ($)"
                  placeholder="Enter amount"
                  type="number"
                  min={0}
                />
                <Input
                  withForm
                  name="description"
                  label="Description"
                  placeholder="Reason for adding credits"
                />
              </Modal.Body>
              <Modal.FooterButtonGroup>
                <Modal.RawClose asChild>
                  <Button>Cancel</Button>
                </Modal.RawClose>
                <Button
                  customType="primary"
                  isLoading={isLoading}
                  disabled={isLoading}
                  onClick={submitForm}
                >
                  Add credits
                </Button>
              </Modal.FooterButtonGroup>
            </>
          )}
        </FormikForm>
      </Modal.Content>
    </Modal.Root>
  );
};
